import { LocalStorage } from "@swiggy-private/core-ui";
import { ORIGINAL_BUSINESS_LINE } from "@checkout-core/constants/Metrics";

export const clearAuthHeadersFromStorage = (): void => {
    LocalStorage.removeItem("auth_headers");
};

export function getOriginalBusinessLine(): string | null {
    // possible values are string or null, null in case local storage is not available
    const originalBusinessLine = LocalStorage.getItem(ORIGINAL_BUSINESS_LINE, null);
    return originalBusinessLine as string | null;
}
